import { render, staticRenderFns } from "./Infobox.vue?vue&type=template&id=34b86c6a&scoped=true&"
import script from "./Infobox.vue?vue&type=script&lang=js&"
export * from "./Infobox.vue?vue&type=script&lang=js&"
import style0 from "./Infobox.vue?vue&type=style&index=0&id=34b86c6a&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b86c6a",
  null
  
)

export default component.exports